var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"spinner-container",staticClass:"spinner-container"},[_c('div',{ref:"custom-spinner",staticClass:"custom-spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }